"use client";

import { createContext, useContext, useState, ReactNode } from "react";

interface LoadingContextType {
  loading: boolean;
  showpageloading: () => void;
  hidepageloading: () => void;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) throw new Error("useLoading must be used within LoadingProvider");
  return context;
};

export default function LoadingProviderWrapper({ children }: { children: ReactNode }) {
  const [loading, setLoading] = useState(false);

  const showpageloading = () => setLoading(true);
  const hidepageloading = () => setLoading(false);

  return (
    <LoadingContext.Provider value={{ loading, showpageloading, hidepageloading }}>
      {children}
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <img src="/spinner-icon.jpg" alt="Loading..." style={{ width: 100, height: 100 }} />
        </div>
      )}
    </LoadingContext.Provider>
  );
}
